import {ArrowLeft, Sparkles} from 'lucide-react';
import {motion} from 'motion/react';
import type {Gender} from '../../../types/domain';

interface Props {
    gender: Gender;
    onGenderChange: (g: Gender) => void;
    onBack: () => void;
    onSubmit: () => void;
}

export function StepVocal({gender, onGenderChange, onBack, onSubmit}: Props) {
    const options = [
        {
            value: 'male' as Gender,
            content: <div className="text-5xl sm:text-6xl mb-2 sm:mb-4">👨</div>,
            label: 'Мужской вокал',
            active: 'from-blue-600 to-blue-400',
            border: 'border-blue-300',
            hover: 'hover:border-blue-400',
            colSpan: 'col-span-1',
        },
        {
            value: 'female' as Gender,
            content: <div className="text-5xl sm:text-6xl mb-2 sm:mb-4">👩</div>,
            label: 'Женский вокал',
            active: 'from-pink-600 to-pink-400',
            border: 'border-pink-300',
            hover: 'hover:border-pink-400',
            colSpan: 'col-span-1',
        },
        {
            value: 'duet' as Gender,
            content: (
                <div className="flex justify-center items-center h-[75px] sm:h-[90px] mb-2 sm:mb-4">
                    <img
                        src="/duet.png"
                        alt="Дуэт"
                        className="h-full w-auto object-contain drop-shadow-sm transition-transform scale-110 hover:scale-125 mix-blend-multiply"
                    />
                </div>
            ),
            label: 'Дуэт М+Ж',
            active: 'from-purple-600 to-pink-400',
            border: 'border-purple-300',
            hover: 'hover:border-purple-400',
            colSpan: 'col-span-2',
        },
    ] as const;

    return (
        <motion.div
            key="vocal"
            initial={{opacity: 0, x: 100}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: -100}}
            className="max-w-2xl w-full"
        >
            <button
                onClick={onBack}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
            >
                <ArrowLeft className="w-5 h-5"/>
                Назад
            </button>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-8 text-center bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Кто исполнит вашу песню?
            </h2>

            <div className="bg-white/80 backdrop-blur-md rounded-3xl p-4 sm:p-8 space-y-4 sm:space-y-6 shadow-xl">
                <div className="grid grid-cols-2 gap-3 sm:gap-6">
                    {options.map(({value, content, label, active, border, hover, colSpan}) => (
                        <button
                            key={value}
                            onClick={() => onGenderChange(value)}
                            className={`p-4 sm:p-8 rounded-2xl text-center transition-all ${colSpan} ${
                                gender === value
                                    ? `bg-gradient-to-br ${active} text-white shadow-xl border-4 ${border}`
                                    : `bg-white border-2 border-gray-300 text-gray-700 ${hover}`
                            }`}
                        >
                            {content}
                            <div className="text-sm sm:text-xl font-bold">{label}</div>
                        </button>
                    ))}
                </div>

                <button
                    onClick={onSubmit}
                    className="w-full px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all flex items-center justify-center gap-2"
                >
                    <Sparkles className="w-6 h-6"/>
                    Создать песню
                </button>
            </div>
        </motion.div>
    );
}